import * as React from "react";
const InfoCircleFilled = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9Zm10-2h-2l-1 2h1v3l-1 1v1h4v-1l-1-1v-5Zm0-3h-2v2h2V7Z" }));
InfoCircleFilled.displayName = "InfoCircleFilled";
var InfoCircleFilled_default = InfoCircleFilled;
export {
  InfoCircleFilled_default as default
};
